export const DEVICE_FORM_FIELDS = [
  {
    label: 'Название модели',
    name: 'model',
    type: 'text',
    required: true,
    rules: {
      required: 'Обязательно для заполнения',
    },
  },
  {
    label: 'МПИ в годах',
    name: 'years',
    type: 'text',
    required: true,
    rules: {
      required: 'Обязательно для заполнения',
      pattern: {
        value: /^[0-9]+$/,
        message: 'Только цифры',
      },
    },
  },
  {
    label: 'Тарифность',
    name: 'tariffsCount',
    type: 'text',
    required: true,
    rules: {
      required: 'Обязательно для заполнения',
      pattern: {
        value: /^[0-9]+$/,
        message: 'Только цифры',
      },
    },
  },
  {
    label: 'Фазность',
    name: 'fazesCount',
    type: 'text',
    required: true,
    rules: {
      required: 'Обязательно для заполнения',
      pattern: {
        value: /^[0-9]+$/,
        message: 'Только цифры',
      },
    },
  },
  {
    label: 'Тип устройства',
    name: 'deviceType',
    type: 'select',
    required: true,
    optionsKey: 'deviceTypes', // Ключ для массива опций
    rules: {
      required: 'Обязательно для заполнения',
    },
  },
] as const;

export const REQUIRED_STYLE = {
  color: '#EB3333',
};

export const LABEL_STYLE = {
  color: '#00203399',
};
